var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChlore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.336,
    height: 53.336,
    viewBox: "0 0 53.336 53.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 53.336,
    height: 53.336,
    rx: 15,
    transform: "translate(0)",
    fill: "#fb0",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 23.543,
    height: 24.078,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_337",
    "data-name": "Groupe 337",
    transform: "translate(45.624 -2672.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_42",
    "data-name": "Groupe de masques 42",
    transform: "translate(-45.624 2672.17)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 53.336,
    height: 53.336,
    transform: "translate(0 0)",
    fill: "#fb0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_261",
    "data-name": "Groupe 261",
    transform: "translate(-32.258 2693.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_260",
    "data-name": "Groupe 260",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_367",
    "data-name": "Trac\\xE9 367",
    d: "M17.032,33.661a14.3,14.3,0,0,1-5.944,1.069C4.742,34.729,0,30.722,0,23.308c0-7.08,4.776-11.822,11.755-11.822a12.189,12.189,0,0,1,5.343,1l-.735,2.371a10.309,10.309,0,0,0-4.508-.935c-5.276,0-8.783,3.373-8.783,9.284,0,5.544,3.173,9.05,8.616,9.05a11.681,11.681,0,0,0,4.776-.935Z",
    transform: "translate(0 -10.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 2.939,
    height: 23.711,
    transform: "translate(20.604)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Chlore",
    d: "M3.99,8.224q-.851,0-1.441-.3t-.9-.851Q1.337,6.522,1.3,5.744q-.009-.375-.009-.805T1.3,4.116q.037-.768.352-1.327t.906-.855q.59-.3,1.432-.3.622,0,1.116.165t.842.453q.348.288.54.672t.2.833q.009.082-.05.137T6.5,3.951H5.628q-.1,0-.165-.05t-.091-.169q-.146-.6-.5-.823t-.887-.22q-.613,0-.979.343t-.393,1.13q-.027.75,0,1.537T3,6.828q.366.343.979.343.531,0,.887-.224t.5-.819Q5.4,6,5.463,5.955t.165-.046H6.5q.082,0,.142.055t.05.137q-.009.448-.2.833t-.54.672q-.348.288-.842.453T3.99,8.224ZM7.9,8.132a.236.236,0,0,1-.044,0A.205.205,0,0,1,7.775,8.1a.231.231,0,0,1-.034-.028Q7.677,8,7.677,7.913V1.856q0-.091.064-.156T7.9,1.637h.814q.1,0,.16.064t.059.156V3.942q.247-.293.6-.476t.878-.183q.558,0,.974.252t.645.709q.229.457.229,1.1V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0h-.823a.236.236,0,0,1-.044,0A.205.205,0,0,1,11.1,8.1a.231.231,0,0,1-.034-.028Q11,8,11,7.913V5.4q0-.531-.261-.833t-.755-.3q-.476,0-.764.3T8.931,5.4V7.913q0,.091-.059.156a.2.2,0,0,1-.032.028.191.191,0,0,1-.037.02.216.216,0,0,1-.043.012.273.273,0,0,1-.048,0Zm5.755,0a.236.236,0,0,1-.044,0A.205.205,0,0,1,13.53,8.1a.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V1.856q0-.091.064-.156t.156-.064h.759q.091,0,.156.064t.064.156V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Zm4.3.091q-.732,0-1.23-.256t-.759-.723q-.261-.467-.3-1.089-.009-.165-.009-.4t.009-.4q.037-.631.306-1.093t.768-.718q.5-.256,1.212-.256t1.212.256q.5.256.768.718t.306,1.093q.009.165.009.4t-.009.4q-.037.622-.3,1.089t-.759.723Q18.683,8.224,17.951,8.224Zm0-.906q.485,0,.75-.306t.293-.9Q19,5.973,19,5.753T18.994,5.4q-.027-.586-.293-.9t-.75-.311q-.485,0-.75.311t-.293.9q-.009.137-.009.357t.009.357q.027.595.293.9T17.951,7.318Zm3.531.814a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V3.6q0-.1.064-.165t.156-.064h.741q.091,0,.16.064t.069.165v.375q.21-.293.544-.448t.773-.156h.375q.1,0,.16.064t.059.156v.659q0,.091-.059.156t-.16.064h-.714q-.439,0-.682.247t-.242.677V7.913q0,.091-.064.156a.216.216,0,0,1-.034.028.208.208,0,0,1-.039.02.228.228,0,0,1-.043.012.278.278,0,0,1-.048,0Zm5.581.091q-1.016,0-1.61-.586t-.64-1.665Q24.8,5.882,24.8,5.74t.009-.224q.037-.686.316-1.189t.773-.773q.494-.27,1.162-.27.741,0,1.244.306t.759.851q.256.544.256,1.258v.192q0,.091-.064.156t-.165.064H26.057t0,.027q0,.027,0,.046.009.32.124.59t.338.435q.224.165.535.165.256,0,.43-.078t.284-.178q.11-.1.156-.165.082-.11.133-.133t.151-.023h.787q.091,0,.151.055t.05.137q-.009.146-.151.357t-.407.412q-.265.2-.663.334T27.063,8.224ZM26.057,5.342h2.022V5.314q0-.357-.119-.622t-.348-.421q-.229-.156-.549-.156t-.549.156q-.229.156-.343.421t-.114.622Z",
    transform: "translate(-36.141 2677.333)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChlore);
export default __webpack_public_path__ + "static/media/CHLORE.29a00a06998216e69512461977bef247.svg";
export { ForwardRef as ReactComponent };